import { jsxs as n, jsx as s, Fragment as u } from "react/jsx-runtime";
import { Button as c } from "../Button/Button.js";
import { Spinner as N } from "../Spinner/Spinner.js";
import { Step as f } from "./Step.js";
import '../../assets/Stepper.css';function B({
  titles: o,
  children: t,
  state: e,
  style: a,
  dispatch: l,
  className: m = "",
  backLabel: d = "Back",
  nextLabel: b = "Next",
  duration: v = 500,
  onNextStep: h
}) {
  const i = async (r) => {
    if (r < 0)
      return l({
        type: "close"
      });
    l({
      type: "loading",
      step: r
    }), setTimeout(() => {
      h(r);
    }, v);
  };
  return /* @__PURE__ */ n("div", { className: "stepper " + m, style: a, children: [
    /* @__PURE__ */ s("div", { className: "stepper-steps", children: o.map((r, p) => /* @__PURE__ */ s(
      f,
      {
        title: r,
        step: p,
        isActive: p === e.step,
        isLast: p === o.length - 1,
        isDone: p < e.step,
        onClick: e.step > p ? () => i(p) : void 0
      },
      r
    )) }),
    /* @__PURE__ */ s("div", { className: "stepper-body", children: e.progress ? /* @__PURE__ */ s("div", { className: "stepper-progress", children: /* @__PURE__ */ s(N, { width: "3rem" }) }) : /* @__PURE__ */ s(u, { children: t }) }),
    /* @__PURE__ */ n("div", { className: "stepper-buttons", children: [
      /* @__PURE__ */ s(
        c,
        {
          label: d,
          variant: "outline",
          onClick: () => i(e.step - 1),
          disabled: !e.isBackEnable
        }
      ),
      /* @__PURE__ */ s(
        c,
        {
          label: b,
          onClick: () => i(e.step + 1),
          disabled: !e.isNextEnable
        }
      )
    ] })
  ] });
}
export {
  B as Stepper
};
//# sourceMappingURL=Stepper.js.map
